/**
 * Application version metadata, injected at build time via Vite `define`
 * (see the `define` block in vite.config.ts, phase C.1).
 *
 * This module is the single source of truth for:
 *  - the version headers sent on every request (phase C.2),
 *  - the `/api/v1/app/version/` compatibility check (phase C.3),
 *  - the sync-queue backup export payload (phase C.7).
 *
 * Nothing else should read the raw `__APP_VERSION__` / `__API_VERSION__` /
 * `__SYNC_SCHEMA_VERSION__` globals directly.
 */

/** Full build identity, e.g. `0.1.0+build.42.sha.abc1234` (`+build.0.sha.<short git sha>` in dev). */
export const APP_VERSION: string = __APP_VERSION__;

/** API contract version the client targets, e.g. `v1`. */
export const API_VERSION: string = __API_VERSION__;

/**
 * Logical version of the offline sync-queue payload contract. Stamped onto every
 * queued operation at enqueue time (phase C.8) and sent as `X-Sync-Schema-Version`
 * (C.2). The backend compares it against `minimumSyncSchemaVersion` and answers
 * `426 sync_schema_version_unsupported` when this client is too old.
 *
 * BUMP THIS (in `vite.config.ts`'s `define`) ONLY when the *shape, semantics, or
 * server-side validation* of a sync payload changes — e.g. a new required field,
 * a renamed/retyped field, or a changed endpoint contract. Do NOT bump for purely
 * visual/UI changes or for client-only refactors that leave the wire payload
 * identical. A bump means previously-queued offline items may no longer be
 * accepted by the new backend, which is exactly what the forced-update backup
 * (C.7) exists to safeguard.
 */
export const SYNC_SCHEMA_VERSION: number = __SYNC_SCHEMA_VERSION__;
